// extracted by mini-css-extract-plugin
export var orderDetails = "_sv-2";
export var orderImage = "_sv-1";
export var orderMeta = "_sv-3";
export var orderSummary = "_sv-0";
export var rightArrow = "_sv-4";